import { ReactNode } from 'react'
import { useOutletContext } from 'react-router-dom'

export type PageOutletContext = {
  setSidePanelAddOn: (node: ReactNode) => void
}

export const useSidePanelOutletContext = (): PageOutletContext => useOutletContext<PageOutletContext>()
